import { Pipe, PipeTransform } from '@angular/core';
import { DiscrepancyReasons } from '@app/shared/models/business-model/delivery-note-discrepancies';
import { StorageService } from '@app/core/services/client-services/storage-service/storage.service';

@Pipe({ name: 'humanReadableDiscrepancyReason', })
export class TranslateDiscrepancyReasonsPipe implements PipeTransform {
    discrepancyReasons: DiscrepancyReasons[];

    constructor(private storageService: StorageService) {
        this.discrepancyReasons =
            this.storageService.getItemAsObject('discrepancyReasons');
    }

    transform(reason: number): string {
        if (reason) {
            return this.discrepancyReasons.filter(r => r.reasonId === reason)[0]
                .name;
        }
        return '';
    }
}
